import React from 'react';
import { motion } from 'framer-motion';
import { Instagram, MapPin, Star } from 'lucide-react';
const sponsors = [{
  id: 'logo-dra-ysailis',
  name: 'Dra. Ysailis Martínez',
  role: 'Médico Especialista',
  specialty: 'Ginecología y Obstetricia',
  location: 'Caracas, Venezuela',
  instagram: 'draysailismartinez',
  instagramUrl: 'https://instagram.com/draysailismartinez',
  logoBg: '#F7F0FF',
  logo: 'https://cdn.magicpatterns.com/uploads/afeSSxNAwDHZk6JYVxoxH2/logo_Dra_Ysalismar.png'
}, {
  id: 'logo-profem',
  name: 'Centro Médico Especializado Profem',
  role: 'Especialistas en Salud',
  specialty: 'Femenina Integral',
  location: 'Caracas, Venezuela',
  instagram: 'profemm.ccs',
  instagramUrl: 'https://instagram.com/profemm.ccs',
  logoBg: '#F0F7FF',
  logo: 'https://cdn.magicpatterns.com/uploads/1B2b7auTxY5FNgSa4y8xuc/Logo_Centro_medico_Especializado_Profem.jpg'
}];
function SectionHeader() {
  return <div className="text-center mb-12" data-id="element-191">
      <div className="flex items-center justify-center gap-4 mb-4" data-id="element-192">
        <span className="h-px w-12 sm:w-20 bg-brand-cardPurple" data-id="element-193" />
        <p className="text-xs sm:text-sm font-semibold uppercase tracking-[0.2em]" style={{
        color: '#6B4C8A'
      }} data-id="element-194">
          Respaldada y Recomendada Por
        </p>
        <span className="h-px w-12 sm:w-20 bg-brand-cardPurple" data-id="element-195" />
      </div>
      <h2 className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold" style={{
      color: '#2D1B4E'
    }} data-id="element-196">
        Profesionales médicos que confían en esta guía
      </h2>
    </div>;
}
export function Sponsors() {
  return <section className="py-16 sm:py-20 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto" data-id="element-197">
      <SectionHeader data-id="element-198" />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-199">
        {sponsors.map((s, index) => <motion.div key={s.id} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} whileHover={{
        scale: 1.02
      }} className="rounded-[16px] p-8 flex flex-col items-center text-center transition-shadow hover:shadow-lg" style={{
        backgroundColor: '#FAFAFA',
        border: '1px solid #E8D5FF',
        boxShadow: '0 4px 20px rgba(181,101,167,0.10)'
      }} data-id="element-200">
            <div className="flex items-center justify-center rounded-lg mb-5 overflow-hidden p-2" style={{
          width: 160,
          height: 160,
          backgroundColor: s.logoBg
        }} data-id="element-201">
              <img id={s.id} src={s.logo} alt={`Logo ${s.name}`} className="max-w-full max-h-full object-contain" data-id="element-202" />
            </div>

            <h3 className="font-body font-semibold text-lg leading-tight mb-1" style={{
          color: '#2D1B4E'
        }} data-id="element-203">
              {s.name}
            </h3>
            <p className="font-body text-sm leading-snug" style={{
          color: '#6B4C8A'
        }} data-id="element-204">
              {s.role}
              <br data-id="element-205" />
              {s.specialty}
            </p>

            <div className="flex items-center gap-1.5 text-sm mt-3 mb-4" style={{
          color: '#6B4C8A'
        }} data-id="element-206">
              <MapPin className="w-4 h-4" data-id="element-207" />
              <span data-id="element-208">{s.location}</span>
            </div>

            <a href={s.instagramUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 font-semibold text-sm rounded-full transition-all" style={{
          backgroundColor: '#F7E8FF',
          color: '#B565A7',
          padding: '6px 14px'
        }} onMouseEnter={e => {
          e.currentTarget.style.backgroundColor = '#B565A7';
          e.currentTarget.style.color = '#FFFFFF';
        }} onMouseLeave={e => {
          e.currentTarget.style.backgroundColor = '#F7E8FF';
          e.currentTarget.style.color = '#B565A7';
        }} data-id="element-209">
              <Instagram className="w-4 h-4" data-id="element-210" />
              <span data-id="element-211">@{s.instagram}</span>
            </a>

            <div className="inline-flex items-center gap-1.5 mt-5 px-3 py-1 rounded-full text-xs font-semibold text-white" style={{
          backgroundColor: '#C9A84C'
        }} data-id="element-212">
              <Star className="w-3.5 h-3.5 fill-white" data-id="element-213" />
              Patrocinante Oficial
            </div>
          </motion.div>)}
      </div>

      <p className="text-center mt-10 italic text-sm sm:text-base" style={{
      color: '#6B4C8A'
    }} data-id="element-214">
        💜 Esta guía cuenta con el respaldo de profesionales médicos
        certificados en Venezuela
      </p>
    </section>;
}
export function SponsorsCompact() {
  return <div className="max-w-3xl mx-auto mb-8" data-id="element-215">
      <div className="flex items-center justify-center gap-4 mb-5" data-id="element-216">
        <span className="h-px w-8 sm:w-12 bg-brand-cardPurple" data-id="element-217" />
        <p className="text-[10px] sm:text-xs font-semibold uppercase tracking-[0.2em]" style={{
        color: '#6B4C8A'
      }} data-id="element-218">
          Respaldada y Recomendada Por
        </p>
        <span className="h-px w-8 sm:w-12 bg-brand-cardPurple" data-id="element-219" />
      </div>

      <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-10 mb-4" data-id="element-220">
        {sponsors.map(s => <div key={s.id} className="flex flex-col items-center text-center" data-id="element-221">
            <div className="flex items-center justify-center rounded-lg mb-3 overflow-hidden p-1" style={{
          width: 110,
          height: 110,
          backgroundColor: s.logoBg
        }} data-id="element-222">
              <img id={`${s.id}-footer`} src={s.logo} alt={`Logo ${s.name}`} className="max-w-full max-h-full object-contain" data-id="element-223" />
            </div>
            <p className="font-body font-semibold text-sm leading-tight mb-2 max-w-[180px]" style={{
          color: '#2D1B4E'
        }} data-id="element-224">
              {s.name}
            </p>
            <a href={s.instagramUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 font-semibold text-xs rounded-full transition-all" style={{
          backgroundColor: '#F7E8FF',
          color: '#B565A7',
          padding: '4px 10px'
        }} onMouseEnter={e => {
          e.currentTarget.style.backgroundColor = '#B565A7';
          e.currentTarget.style.color = '#FFFFFF';
        }} onMouseLeave={e => {
          e.currentTarget.style.backgroundColor = '#F7E8FF';
          e.currentTarget.style.color = '#B565A7';
        }} data-id="element-225">
              <Instagram className="w-3 h-3" data-id="element-226" />
              <span data-id="element-227">@{s.instagram}</span>
            </a>
          </div>)}
      </div>

      <p className="text-center italic text-xs sm:text-sm" style={{
      color: '#6B4C8A'
    }} data-id="element-228">
        Con el respaldo de nuestros patrocinantes médicos oficiales
      </p>
    </div>;
}